import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Dispatch } from 'redux';
import urlencode from 'urlencode';
import { anonymousLogin } from '../../stores/auth/actionCreators';
import { invalidToken } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import CenterContainer from '../layout/CenterContainer';
import LoadingScreen from '../navigation/LoadingScreen';

export interface Props extends RouteComponentProps, LocalizeContextProps {
    invalidToken?: boolean;

    anonymousLogin: (token: string) => void;
}

export class AnonymousLoginPage extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        const { token } = urlencode.parse(this.props.location.search.substr(1), { charset: 'utf-8' });
        this.props.anonymousLogin(token);
    }

    public render() {
        const t = this.props.translate;
        if (this.props.invalidToken) {
            return (
                <CenterContainer>

                    <Card>
                        <CardBody>
                            <CardTitle tag="h3">{t('anonymousLogin.header.anonymousLogin')}</CardTitle>
                            <p>{t('anonymousLogin.error.INVALID_TOKEN')}</p>
                            <Link to="/login">
                                {t('anonymousLogin.link.backToLogin')}
                            </Link>
                        </CardBody>
                    </Card>
                </CenterContainer >
            );
        }
        return <LoadingScreen text={t('anonymousLogin.loading.loading') as string} />;
    }
}

const mapStateToProps = (state: RootState) => ({
    invalidToken: invalidToken(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    anonymousLogin: (token: string) => dispatch(anonymousLogin(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(AnonymousLoginPage)));
